// src/firebase.js

import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// 🟢 CORREÇÃO: Usar ./ (ponto barra) pois este arquivo está na raiz de src
import { globalFirebaseConfig } from "./utils/constants";

// Padrão Singleton
const app = !getApps().length ? initializeApp(globalFirebaseConfig) : getApp();

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;